export default {
  create: 'Create',
  closeCreate: 'Close Create',
  openCommandMenu: 'Open command menu',
  closeCommandMenu: 'Close command menu',
  openCategory: 'Open category',
  openCategoryNamed: 'Open {{category}}',
  createNewSplit: 'Create new split',
  toggleSettings: 'Toggle settings',
  account: 'Account',
  logout: 'Logout',
  mcpSetup: 'MCP setup',
  changeTheme: 'Change theme',
  systemPreference: 'System preference',
  setDefaultLightTheme: 'Set default light theme',
  setDefaultDarkTheme: 'Set default dark theme',
  autoDetectColorScheme: 'Auto-detect color scheme',
  turnOffAutoDetectColorScheme: 'Turn off auto-detect color scheme',
  uploadFiles: 'Upload files',
  uploadFolders: 'Upload folders',
  undo: 'Undo',
  redo: 'Redo',
  failedToUndo: 'Failed to undo',
  failedToSignOut: 'Failed to sign out',
  failedToRedo: 'Failed to redo',
  favorites: 'Favorites',
  backToList: 'Back to list',
  closeSplit: 'Close split',
  maximizeSplit: 'Maximize {{name}}',
  goBack: 'Go back',
  goForward: 'Go forward',
  focusSplitRight: 'Focus split right',
  focusSplitLeft: 'Focus split left',
};
